module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-index-thumb-20411a13.svg";